// Base URL without trailing slash
export const BASE_URL = "https://go-convex.com/api/";
